export default "__VITE_ASSET__DhWiSq0f__"